const $accordeonItems = $('.accordeon-item');

$accordeonItems.each(function () {
    if ($(this).hasClass('_opened')) {
        $(this).addClass('_active').find('.accordeon-item__content').css({'display': 'block'});
    }
});

App.H.on('click', '.accordeon-item__button, .accordeon-item__title, .accordeon-item__head', function(e) {
    e.preventDefault();

    const $currAccordeon = $(this).closest('.accordeon');
    const isAccordeon = $currAccordeon.is('[data-collapsing]');
    const $currAccordeonItems = $currAccordeon.find('.accordeon-item');
    const $currAccordeonItemsContents = $currAccordeon.find('.accordeon-item__content');
    const $currItem = $(this).closest('.accordeon-item');
    const $currItemContent = $currItem.find('.accordeon-item__content');
    const isActive = $currItem.is('._active');

    if (isAccordeon) {
        $currAccordeonItems.removeClass('_active');
        $currAccordeonItemsContents.stop().slideUp(200);

        if (isActive) {
            $currItem.find('.accordeon-item__content').stop().slideUp(200);
            $currItem.removeClass('_active');
        } else {
            $currItem.addClass('_active');
            $currItem.find('.accordeon-item__content').clearQueue().slideDown(200);
        }
    } else {
        $currItem.toggleClass('_active');
        $currItemContent.clearQueue().slideToggle(200);
    }

});

const $toggleItems = $('.js-toggle-item');
const $toggleContents = $('.js-toggle-content');

App.H.on('click', '.js-toggle-btn, .js-toggle-link', function(e) {
    e.preventDefault();

    const _isAccordeon = $(this).closest('.js-toggle-item').hasClass('_accordeonable');
    const $item = $(this).closest('.js-toggle-item');
    const $itemContent = $item.find('.js-toggle-content');
    const _isActive = $item.is('._active');

    if (_isAccordeon) {
        $toggleItems.removeClass('_active');
        $toggleContents.stop().slideUp(200);

        if ( _isActive ) {
            $item.find('.js-toggle-content').stop().slideUp(200);
        } else {
            $item.addClass('_active');
            $item.find('.js-toggle-content').stop().slideDown(200);
        }
    } else {
        $item.toggleClass('_active');
        $itemContent.clearQueue().slideToggle(200);
    }
});
